import { useDarkmode } from 'hooks/useTheme';
import { QRCodeSVG } from 'qrcode.react';

const CheckInCode = ({parent, checkinCode}) => {
    const { darkmode } = useDarkmode();

    return (
        <>
            <div className="flex-1 max-w-[390px] py-2">
                <h1 className="text-3xl font-bold">Show QR code to staff member to check-in your children.</h1>

                <div className="rounded-2xl bg-white dark:bg-navy-700 p-5 mt-8">
                    <p className="text-gray-700 text-sm">Parent</p>
                    <p className="text-base font-medium">{parent.firstName} {parent.lastName}</p>
                </div>

                <div className="flex flex-col items-center rounded-2xl bg-white dark:bg-navy-700 p-8 mt-2">
                    <QRCodeSVG value={checkinCode} size={240} bgColor={'transparent'} fgColor={darkmode ? 'white' : '#1F264E'}/>
                </div>
            </div>
        </>
    )
}

export default CheckInCode;